'use client'

import Hint, {HintLink} from "@/app/components/Hint";
import { GameManager } from "@/app/lib/game-state/game-manager";
import UI from "@/app/lib/ui/ui";
import { useEffect, useState } from "react";

type NewURLWarningProps = {
    gameManager: GameManager
    ui: UI
}

export default function NewURLWarning({gameManager, ui}: NewURLWarningProps) {

    const [element, setElement] = useState<Element | null>(null);

    const hintText = `Word Salad is now Alphabet Soup and has moved to playalphabetsoup.com.`
    const hintLinks: HintLink[] = [{
        text: 'Go there!',
        callback: () => {
            window.location.href = 'https://playalphabetsoup.com/'
    }}]

    useEffect(() => {
        setElement(ui.letterRefs.current?.[3]?.[1] ?? null);
    },[
        ui.isLoaded,
    ])

    if (!element) {
        return null;
    }

    if (!ui.isLoaded[gameManager.activeMode]) {
        return null;
    }

    const domain = typeof window !== "undefined"
        ? window.location.origin
        : "";

    if (
        domain !== 'https://www.playwordsalad.com/'
        && domain !== 'https://www.playwordsalad.com'

    ) {
        return null;
    }

    return (
        <>
            <Hint 
                element={element}
                text={hintText}
                greyOverlay={true}
                links={hintLinks}
            />
        </>
    )
}